import {Component} from '@angular/core';
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-owner',
  templateUrl: './owner.component.html',
  imports: [
    RouterOutlet
  ],
  styleUrls: ['./owner.component.scss']
})
export class OwnerComponent {

}
